<template>
  <div class="declaration-scope">
    <div style="display: flex;">
      <div class="show-right section" style="width: 60%;background-color: #FFFFFF;">
        <div class="main-content left" style="margin-left: 20px;margin-bottom: 50px;">
          <el-form :inline="true" :disabled="useHqSet" label-width="130px" label-position="left">
            <div class="el-form-item-wrapper" style="margin-top: 10px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_UnregisteredShippingRate') }}</span>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <el-radio-group v-model="form.declaredWarnType">
                  <el-radio :label="1" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_ProhibitSaving') }}</el-radio>
                  <el-radio :label="2" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NotifyUser') }}</el-radio>
                  <el-radio :label="3" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_RecordOnly') }}</el-radio>
                  <el-radio :label="4" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NoRecordNoAlert') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.declaredWarnRole" no="declaredWarnRole" :disabled="!isEdit" @change="uncheckClearValue(form.declaredWarnRole, 'declaredWarnRoleArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyRoleByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  :disabled="!(isEdit && form.declaredWarnRole)"
                  :placeholder="' '"
                  filterable
                  :static-options="roles"
                  :default-multiple-value="form.declaredWarnRoleArray"
                  :multiple="true"
                  :cache="false"
                  tag-name="code"
                  tag-value="value"
                  style="width: 350px;"
                  :filter-tag-names="['code']"
                  @parentCallBack="p=>{form.declaredWarnRoleArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.declaredWarnUser" no="declaredWarnUser" :disabled="!isEdit" @change="uncheckClearValue(form.declaredWarnUser, 'declaredWarnUserArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPersonByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="declaredWarnUserArray"
                  :disabled="!(isEdit && form.declaredWarnUser)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_User"
                  filterable
                  :clearable="false"
                  :default-multiple-value="form.declaredWarnUserArray"
                  style="width: 350px;"
                  :multiple="true"
                  @parentCallBack="p=>{form.declaredWarnUserArray=p.value}"
                />
              </el-form-item>
            </div>

            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.declaredWarnPosition" no="declaredWarnPosition" :disabled="!isEdit" @change="uncheckClearValue(form.declaredWarnPosition, 'declaredWarnPositionArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPositionByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="declaredWarnPositionArray"
                  :disabled="!(isEdit && form.declaredWarnPosition)"
                  :placeholder="' '"
                  :static-options="positions"
                  filterable
                  :default-multiple-value="form.declaredWarnPositionArray"
                  :multiple="true"
                  tag-name="chineseName"
                  tag-value="code"
                  :custom-label="(item)=>`${item.chineseName}`"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.declaredWarnPositionArray=p.value}"
                />
              </el-form-item>
            </div>

            <!-- 当创建的业务运价超过已维护的界限时 -->
            <div class="el-form-item-wrapper" style="margin-top: 10px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_ExceedMaintainedLimit') }}</span>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <el-radio-group v-model="form.transfiniteWarnType">
                  <el-radio :label="1" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_ProhibitSaving') }}</el-radio>
                  <el-radio :label="2" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NotifyUser') }}</el-radio>
                  <el-radio :label="3" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_RecordOnly') }}</el-radio>
                  <el-radio :label="4" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NoRecordNoAlert') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.transfiniteWarnRole" no="transfiniteWarnRole" :disabled="!isEdit" @change="uncheckClearValue(form.transfiniteWarnRole, 'transfiniteWarnRoleArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyRoleByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  :disabled="!(isEdit && form.transfiniteWarnRole)"
                  :placeholder="' '"
                  filterable
                  :static-options="roles"
                  :default-multiple-value="form.transfiniteWarnRoleArray"
                  :multiple="true"
                  :cache="false"
                  tag-name="code"
                  tag-value="value"
                  :filter-tag-names="['code']"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.transfiniteWarnRoleArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.transfiniteWarnUser" no="transfiniteWarnUser" :disabled="!isEdit" @change="uncheckClearValue(form.transfiniteWarnUser, 'transfiniteWarnUserArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPersonByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="transfiniteWarnUserArray"
                  :disabled="!(isEdit && form.transfiniteWarnUser)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_User"
                  filterable
                  :clearable="false"
                  :default-multiple-value="form.transfiniteWarnUserArray"
                  style="width: 350px;"
                  :multiple="true"
                  @parentCallBack="p=>{form.transfiniteWarnUserArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.transfiniteWarnPosition" no="transfiniteWarnPosition" :disabled="!isEdit" @change="uncheckClearValue(form.transfiniteWarnPosition, 'transfiniteWarnPositionArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPositionByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="transfiniteWarnPositionArray"
                  :disabled="!(isEdit && form.transfiniteWarnPosition)"
                  :placeholder="' '"
                  :static-options="positions"
                  filterable
                  :default-multiple-value="form.transfiniteWarnPositionArray"
                  :multiple="true"
                  tag-name="chineseName"
                  tag-value="code"
                  :custom-label="(item)=>`${item.chineseName}`"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.transfiniteWarnPositionArray=p.value}"
                />
              </el-form-item>
            </div>

            <!-- 当RPA暂停时 -->
            <div class="el-form-item-wrapper" style="margin-top: 10px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_RPAPaused') }}</span>
              </el-form-item>
            </div>
            <!--            <div class="el-form-item-wrapper">-->
            <!--              <el-form-item>-->
            <!--                <el-radio-group v-model="form.rpaPauseWarnType">-->
            <!--                  <el-radio :label="1" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_ProhibitSaving') }}</el-radio>-->
            <!--                  <el-radio :label="2" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NotifyUser') }}</el-radio>-->
            <!--                  <el-radio :label="3" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_RecordOnly') }}</el-radio>-->
            <!--                  <el-radio :label="4" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NoRecordNoAlert') }}</el-radio>-->
            <!--                </el-radio-group>-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.rpaPauseWarnRole" no="rpaPauseWarnRole" :disabled="!isEdit" @change="uncheckClearValue(form.rpaPauseWarnRole, 'rpaPauseWarnRoleArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyRoleByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  :disabled="!(isEdit && form.rpaPauseWarnRole)"
                  :placeholder="' '"
                  filterable
                  :static-options="roles"
                  :default-multiple-value="form.rpaPauseWarnRoleArray"
                  :multiple="true"
                  :cache="false"
                  tag-name="code"
                  tag-value="value"
                  :filter-tag-names="['code']"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.rpaPauseWarnRoleArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.rpaPauseWarnUser" no="rpaPauseWarnUser" :disabled="!isEdit" @change="uncheckClearValue(form.rpaPauseWarnUser, 'rpaPauseWarnUserArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPersonByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="rpaPauseWarnUserArray"
                  :disabled="!(isEdit && form.rpaPauseWarnUser)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_User"
                  filterable
                  :clearable="false"
                  :default-multiple-value="form.rpaPauseWarnUserArray"
                  style="width: 350px;"
                  :multiple="true"
                  @parentCallBack="p=>{form.rpaPauseWarnUserArray=p.value}"
                />
              </el-form-item>
            </div>
            <!--            <div class="el-form-item-wrapper">-->
            <!--              <el-form-item class="form-item">-->
            <!--                <el-checkbox v-model="form.rpaPauseWarnPosition" no="rpaPauseWarnPosition" :disabled="!isEdit" @change="uncheckClearValue(form.rpaPauseWarnPosition, 'rpaPauseWarnPositionArray')" />-->
            <!--                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPositionByEmail') }}</span>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item>-->
            <!--                <cargo-advance-select-->
            <!--                  no="rpaPauseWarnPositionArray"-->
            <!--                  :disabled="!(isEdit && form.rpaPauseWarnPosition)"-->
            <!--                  :placeholder="' '"-->
            <!--                  :static-options="positions"-->
            <!--                  filterable-->
            <!--                  :default-multiple-value="form.rpaPauseWarnPositionArray"-->
            <!--                  :multiple="true"-->
            <!--                  tag-name="chineseName"-->
            <!--                  tag-value="code"-->
            <!--                  :custom-label="(item)=>`${item.chineseName}`"-->
            <!--                  style="width: 350px;"-->
            <!--                  @parentCallBack="p=>{form.rpaPauseWarnPositionArray=p.value}"-->
            <!--                />-->
            <!--              </el-form-item>-->
            <!--            </div>-->

            <!-- 当RPA完成时- -->
            <div class="el-form-item-wrapper" style="margin-top: 10px;">
              <el-form-item>
                <span class="title" style="font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.Cargo_RPACompleted') }}</span>
              </el-form-item>
            </div>
            <!--            <div class="el-form-item-wrapper">-->
            <!--              <el-form-item>-->
            <!--                <el-radio-group v-model="form.rpaCompletedWarnType">-->
            <!--                  <el-radio :label="1" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_ProhibitSaving') }}</el-radio>-->
            <!--                  <el-radio :label="2" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NotifyUser') }}</el-radio>-->
            <!--                  <el-radio :label="3" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_RecordOnly') }}</el-radio>-->
            <!--                  <el-radio :label="4" :disabled="!isEdit" style="font-weight: normal;">{{ $t('CargoMsg.Cargo_NoRecordNoAlert') }}</el-radio>-->
            <!--                </el-radio-group>-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.rpaCompletedWarnRole" no="rpaCompletedWarnRole" :disabled="!isEdit" @change="uncheckClearValue(form.rpaCompletedWarnRole, 'rpaCompletedWarnRoleArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyRoleByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  :disabled="!(isEdit && form.rpaCompletedWarnRole)"
                  :placeholder="' '"
                  filterable
                  :static-options="roles"
                  :default-multiple-value="form.rpaCompletedWarnRoleArray"
                  :multiple="true"
                  :cache="false"
                  tag-name="code"
                  tag-value="value"
                  :filter-tag-names="['code']"
                  style="width: 350px;"
                  @parentCallBack="p=>{form.rpaCompletedWarnRoleArray=p.value}"
                />
              </el-form-item>
            </div>
            <div class="el-form-item-wrapper">
              <el-form-item class="form-item">
                <el-checkbox v-model="form.rpaCompletedWarnUser" no="rpaCompletedWarnUser" :disabled="!isEdit" @change="uncheckClearValue(form.rpaCompletedWarnUser, 'rpaCompletedWarnUserArray')" />
                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPersonByEmail') }}</span>
              </el-form-item>
              <el-form-item>
                <cargo-advance-select
                  no="rpaCompletedWarnUserArray"
                  :disabled="!(isEdit && form.rpaCompletedWarnUser)"
                  :placeholder="' '"
                  :select-type="selectTypeNames.basic_data_User"
                  filterable
                  :clearable="false"
                  :default-multiple-value="form.rpaCompletedWarnUserArray"
                  style="width: 350px;"
                  :multiple="true"
                  @parentCallBack="p=>{form.rpaCompletedWarnUserArray=p.value}"
                />
              </el-form-item>
            </div>
            <!--            <div class="el-form-item-wrapper">-->
            <!--              <el-form-item class="form-item">-->
            <!--                <el-checkbox v-model="form.rpaCompletedWarnPosition" no="rpaCompletedWarnPosition" :disabled="!isEdit" @change="uncheckClearValue(form.rpaCompletedWarnPosition, 'rpaCompletedWarnPositionArray')" />-->
            <!--                <span class="label-span">{{ $t('CargoMsg.Cargo_NotifyPositionByEmail') }}</span>-->
            <!--              </el-form-item>-->
            <!--              <el-form-item>-->
            <!--                <cargo-advance-select-->
            <!--                  no="rpaCompletedWarnPositionArray"-->
            <!--                  :disabled="!(isEdit && form.rpaCompletedWarnPosition)"-->
            <!--                  :placeholder="' '"-->
            <!--                  :static-options="positions"-->
            <!--                  filterable-->
            <!--                  :default-multiple-value="form.rpaCompletedWarnPositionArray"-->
            <!--                  :multiple="true"-->
            <!--                  tag-name="chineseName"-->
            <!--                  tag-value="code"-->
            <!--                  :custom-label="(item)=>`${item.chineseName}`"-->
            <!--                  style="width: 350px;"-->
            <!--                  @parentCallBack="p=>{form.rpaCompletedWarnPositionArray=p.value}"-->
            <!--                />-->
            <!--              </el-form-item>-->
            <!--            </div>-->

          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lodash from 'lodash'
import {
  getAlarmByAviationExchangePrice
} from '@/api/sysManage/aviationExchangePrice'
import { getRoleList } from '@/api/role'
import { TabError } from '@/utils/class/TabError'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'

export default {
  name: 'TabAlarmNotification',
  components: {
    AutoNumberInput,
    CargoAdvanceSelect
  },
  props: {
    isEdit: { type: Boolean, default: false, required: true },
    useHqSet: { type: Boolean, default: false, required: true },
    branchId: { type: Number, default: 0, required: true }
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      isZh: this.$store.getters.language === 'zh',
      selectTypeNames: TYPE_NAMES,
      form: {},
      positions: [],
      roles: []
    }
  },
  computed: {},
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      const roles = await getRoleList({ officeId: 0 }).then(res => res.data)
      if (roles && roles.length > 0) {
        for (const role of roles) {
          const data = {
            code: role.name,
            value: role.roleId
          }
          this.roles.push(data)
        }
      }

      this.positions = CargoOfRoleType.COMPANY_USER_LIST_ROLE_AVIATION_EXCHANGE_WARNING
    },
    initForm() {
      this.form = {
        aviationExchangePriceUuid: '',
        declaredWarnType: 0,
        declaredWarnRole: false,
        declaredWarnRoleArray: [],
        declaredWarnUser: false,
        declaredWarnUserArray: [],
        declaredWarnPosition: false,
        declaredWarnPositionArray: [],
        transfiniteWarnType: 0,
        transfiniteWarnRole: false,
        transfiniteWarnRoleArray: [],
        transfiniteWarnUser: false,
        transfiniteWarnUserArray: [],
        transfiniteWarnPosition: false,
        transfiniteWarnPositionArray: [],
        rpaPauseWarnType: 0,
        rpaPauseWarnRole: false,
        rpaPauseWarnRoleArray: [],
        rpaPauseWarnUser: false,
        rpaPauseWarnUserArray: [],
        rpaPauseWarnPosition: false,
        rpaPauseWarnPositionArray: [],
        rpaCompletedWarnType: 0,
        rpaCompletedWarnRole: false,
        rpaCompletedWarnRoleArray: [],
        rpaCompletedWarnUser: false,
        rpaCompletedWarnUserArray: [],
        rpaCompletedWarnPosition: false,
        rpaCompletedWarnPositionArray: []
      }
    },
    async onShow(data, isRefresh) {
      console.log('isRefresh is', isRefresh)
      if (isRefresh) {
        if (!data || !data.uuid) {
          this.initForm()
          return
        }
        const filter = {
          aviationExchangePriceUuid: data.uuid
        }
        await this.toQuery(filter)
      }
    },
    async toQuery(filter) {
      await getAlarmByAviationExchangePrice(filter).then(res => {
        if (res.data) {
          this.form = res.data
          // 数据转换一下
          this.strConvertArrayData()
        } else {
          this.initForm()
        }
      })
    },
    uncheckClearValue(checked, fieldName) {
      if (!checked) {
        this.form[fieldName] = []
      }
    },
    async getSubmitData() {
      await this.validateForm()
      const data = lodash.cloneDeep(this.form)
      this.arrayConvertStrData(data)
      return {
        aviationExchangePriceAlarm: data
      }
    },
    async validateForm() {
      if (this.useHqSet) { // 如果是总部设置，则不需要验证
        return true
      }
      const roleErrMsg = this.$t('Invoice.BatchCheckRedFlushInvoiceTipOne') + this.$t('CargoMsg.Cargo_NotifyRoleByEmail') + this.$t('queryJob.CannotBeEmpty')
      const userErrMsg = this.$t('Invoice.BatchCheckRedFlushInvoiceTipOne') + this.$t('CargoMsg.Cargo_NotifyPersonByEmail') + this.$t('queryJob.CannotBeEmpty')
      const positionErrMsg = this.$t('Invoice.BatchCheckRedFlushInvoiceTipOne') + this.$t('CargoMsg.Cargo_NotifyPositionByEmail') + this.$t('queryJob.CannotBeEmpty')
      if (this.form.declaredWarnRole && (!this.form.declaredWarnRoleArray || this.form.declaredWarnRoleArray.length === 0)) {
        throw new TabError(roleErrMsg, 'tabAlarmNotification')
      }
      if (this.form.declaredWarnUser && (!this.form.declaredWarnUserArray || this.form.declaredWarnUserArray.length === 0)) {
        throw new TabError(userErrMsg, 'tabAlarmNotification')
      }
      if (this.form.declaredWarnPosition && (!this.form.declaredWarnPositionArray || this.form.declaredWarnPositionArray.length === 0)) {
        throw new TabError(positionErrMsg, 'tabAlarmNotification')
      }

      if (this.form.transfiniteWarnRole && (!this.form.transfiniteWarnRoleArray || this.form.transfiniteWarnRoleArray.length === 0)) {
        throw new TabError(roleErrMsg, 'tabAlarmNotification')
      }
      if (this.form.transfiniteWarnUser && (!this.form.transfiniteWarnUserArray || this.form.transfiniteWarnUserArray.length === 0)) {
        throw new TabError(userErrMsg, 'tabAlarmNotification')
      }
      if (this.form.transfiniteWarnPosition && (!this.form.transfiniteWarnPositionArray || this.form.transfiniteWarnPositionArray.length === 0)) {
        throw new TabError(positionErrMsg, 'tabAlarmNotification')
      }

      if (this.form.rpaPauseWarnRole && (!this.form.rpaPauseWarnRoleArray || this.form.rpaPauseWarnRoleArray.length === 0)) {
        throw new TabError(roleErrMsg, 'tabAlarmNotification')
      }
      if (this.form.rpaPauseWarnUser && (!this.form.rpaPauseWarnUserArray || this.form.rpaPauseWarnUserArray.length === 0)) {
        throw new TabError(userErrMsg, 'tabAlarmNotification')
      }
      if (this.form.rpaPauseWarnPosition && (!this.form.rpaPauseWarnPositionArray || this.form.rpaPauseWarnPositionArray.length === 0)) {
        throw new TabError(positionErrMsg, 'tabAlarmNotification')
      }

      if (this.form.rpaCompletedWarnRole && (!this.form.rpaCompletedWarnRoleArray || this.form.rpaCompletedWarnRoleArray.length === 0)) {
        throw new TabError(roleErrMsg, 'tabAlarmNotification')
      }
      if (this.form.rpaCompletedWarnUser && (!this.form.rpaCompletedWarnUserArray || this.form.rpaCompletedWarnUserArray.length === 0)) {
        throw new TabError(userErrMsg, 'tabAlarmNotification')
      }
      if (this.form.rpaCompletedWarnPosition && (!this.form.rpaCompletedWarnPositionArray || this.form.rpaCompletedWarnPositionArray.length === 0)) {
        throw new TabError(positionErrMsg, 'tabAlarmNotification')
      }
    },
    arrayConvertStrData(data) {
      data.declaredWarnRoleValue = this.arrayConvertToStr(this.form.declaredWarnRoleArray)
      data.declaredWarnUserValue = this.arrayConvertToStr(this.form.declaredWarnUserArray)
      data.declaredWarnPositionValue = this.arrayConvertToStr(this.form.declaredWarnPositionArray)
      data.transfiniteWarnRoleValue = this.arrayConvertToStr(this.form.transfiniteWarnRoleArray)
      data.transfiniteWarnUserValue = this.arrayConvertToStr(this.form.transfiniteWarnUserArray)
      data.transfiniteWarnPositionValue = this.arrayConvertToStr(this.form.transfiniteWarnPositionArray)
      data.rpaPauseWarnRoleValue = this.arrayConvertToStr(this.form.rpaPauseWarnRoleArray)
      data.rpaPauseWarnUserValue = this.arrayConvertToStr(this.form.rpaPauseWarnUserArray)
      data.rpaPauseWarnPositionValue = this.arrayConvertToStr(this.form.rpaPauseWarnPositionArray)
      data.rpaCompletedWarnRoleValue = this.arrayConvertToStr(this.form.rpaCompletedWarnRoleArray)
      data.rpaCompletedWarnUserValue = this.arrayConvertToStr(this.form.rpaCompletedWarnUserArray)
      data.rpaCompletedWarnPositionValue = this.arrayConvertToStr(this.form.rpaCompletedWarnPositionArray)
    },
    strConvertArrayData() {
      this.form.declaredWarnRoleArray = this.strConvertToArray(this.form.declaredWarnRoleValue, true)
      this.form.declaredWarnUserArray = this.strConvertToArray(this.form.declaredWarnUserValue, true)
      this.form.declaredWarnPositionArray = this.strConvertToArray(this.form.declaredWarnPositionValue, true)

      this.form.transfiniteWarnRoleArray = this.strConvertToArray(this.form.transfiniteWarnRoleValue, true)
      this.form.transfiniteWarnUserArray = this.strConvertToArray(this.form.transfiniteWarnUserValue, true)
      this.form.transfiniteWarnPositionArray = this.strConvertToArray(this.form.transfiniteWarnPositionValue, true)

      this.form.rpaPauseWarnRoleArray = this.strConvertToArray(this.form.rpaPauseWarnRoleValue, true)
      this.form.rpaPauseWarnUserArray = this.strConvertToArray(this.form.rpaPauseWarnUserValue, true)
      this.form.rpaPauseWarnPositionArray = this.strConvertToArray(this.form.rpaPauseWarnPositionValue, true)

      this.form.rpaCompletedWarnRoleArray = this.strConvertToArray(this.form.rpaCompletedWarnRoleValue, true)
      this.form.rpaCompletedWarnUserArray = this.strConvertToArray(this.form.rpaCompletedWarnUserValue, true)
      this.form.rpaCompletedWarnPositionArray = this.strConvertToArray(this.form.rpaCompletedWarnPositionValue, true)
    },
    // 将逗号分隔的字符串转换为数组
    strConvertToArray(str, isNumber = false) {
      if (str && str.length > 0) {
        const array = str.split(',')
        if (isNumber) {
          return array.map(Number)
        }
        return array
      }
      return []
    },
    // 将数组转换为逗号分隔的字符串
    arrayConvertToStr(arrys) {
      if (arrys && arrys.length > 0) {
        return arrys.join(',')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.declaration-scope{
  .title{
    display: inline-block;
    position: relative;
    font-size: 18px;
    padding-left: 15px;
    margin-bottom: 10px;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 4px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #1F75D5;
  }
  .el-form-item-wrapper .form-item{
    width: 130px;
  }
  .el-form-item-wrapper .label-span{
    margin-left: 10px;
  }
  /deep/ .el-input-number__increase,
  /deep/ .el-input-number__decrease {
    width: 15px !important; /* 你可以根据需要调整宽度 */
    min-width: 15px !important;
    padding: 0;
  }
}
</style>
